import { render, staticRenderFns } from "./edit-share.vue?vue&type=template&id=306cd3bc&scoped=true"
import script from "./edit-share.vue?vue&type=script&lang=js"
export * from "./edit-share.vue?vue&type=script&lang=js"
import style0 from "./edit-share.vue?vue&type=style&index=0&id=306cd3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306cd3bc",
  null
  
)

export default component.exports